/**
 * Subscription Management Platform API
 * This document describes the functionality of the API belonging to the Subscription Management Platform ## Parameters ### Parameters with type \"array[string]\" or \"array[integer]\" should be given as multiple parameters with same key and different values    * param=A&param=B&param=C    * param=0&param=1&param=2
 *
 * OpenAPI spec version: 2.0.7
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { EISIMPORTPROFILESubscription } from './eISIMPORTPROFILESubscription';


export interface EISIMPORTPROFILE {
    /**
     * Integrated Circuit Card ID
     */
    iccid: string;
    /**
     * ISDP AID
     */
    isdpAid: string;
    mnoId: string;
    fallbackAttribute: boolean;
    subscription: EISIMPORTPROFILESubscription;
    state: EISIMPORTPROFILE.StateEnum;
    smdpId: string;
    allocatedMemory: number;
    freeMemory: number;
    profileType?: string;
}
export namespace EISIMPORTPROFILE {
    export type StateEnum = 'CREATED' | 'ENABLED' | 'DISABLED';
    export const StateEnum = {
        CREATED: 'CREATED' as StateEnum,
        ENABLED: 'ENABLED' as StateEnum,
        DISABLED: 'DISABLED' as StateEnum
    }
}



// WEBPACK FOOTER //
// ./src/gen/swagger-api/model/eISIMPORTPROFILE.ts